import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang';// 语言包

//导入UI框架
import Vant, { Lazyload } from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant, { i18n: (key, value) => i18n.t(key, value) });
//导入ElementUI文件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI);


//导入自己的重置文件
import './assets/css/rester.css';
import './assets/css/common.css';
//导入animate.css文件
import 'animate.css';

import '@/assets/css/iconfont/iconfont.css'

Vue.directive('lazy',{
  bind: function(el,binding){
    // console.log(binding)
    let LazyLoadObser = new IntersectionObserver((entries,observe)=>{
      entries.forEach((entry,index)=>{
        let lazyImage = entry.target;
        // console.log(entry);
        if(entry.intersectionRatio > 0){
          // console.log(binding)
          binding.value.throttle(binding.value.getData,200)(binding.value.id,LazyLoadObser,lazyImage)
        }
      })
    })
    LazyLoadObser.observe(el)
  }
})


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
